/** 발사 원점·조준 타겟 등 2D 좌표. NearestBrickLocator 반환형·FireOrigin과 구조 호환. */
export interface Vec2 {
  readonly x: number;
  readonly y: number;
}

export const DEFAULT_AIM_ANGLE_RAD = -Math.PI / 2;

function isFiniteVec2(v: Vec2): boolean {
  return Number.isFinite(v.x) && Number.isFinite(v.y);
}

export function isAimTargetAboveOrigin(origin: Vec2, target: Vec2 | null): target is Vec2 {
  return target !== null && isFiniteVec2(origin) && isFiniteVec2(target) && target.y < origin.y;
}

/**
 * 발사/조준 기준 각도(rad). 발사체(ProjectileFactory)와 조준선(GameScene.updateAimLine)의
 * 단일 출처(SSoT) — 두 소비자가 같은 origin·target으로 호출하면 동일 각도를 보장한다.
 * 타겟이 없거나 발사 원점보다 위가 아니면 -PI/2(수직 위)로 폴백한다.
 */
export function aimBaseAngleRad(origin: Vec2, target: Vec2 | null): number {
  if (!isAimTargetAboveOrigin(origin, target)) return DEFAULT_AIM_ANGLE_RAD;
  const angle = Math.atan2(target.y - origin.y, target.x - origin.x);
  return Number.isFinite(angle) ? angle : DEFAULT_AIM_ANGLE_RAD;
}

/**
 * 포구(포신 끝) 좌표 — 회전축(origin)에서 조준 각도(rad)로 length만큼 전방. 발사체 시작 위치와 머즐
 * 플래시를 포신 끝에 정렬하는 SSoT. length는 COMBAT.launcherMuzzleLength(포신 텍스처 축→포구 거리).
 */
export function muzzleTip(origin: Vec2, angleRad: number, length: number): Vec2 {
  return {
    x: origin.x + Math.cos(angleRad) * length,
    y: origin.y + Math.sin(angleRad) * length,
  };
}
